import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TABS = [
  { path: '/fryser',        icon: '❄️',  key: 'freezer'  },
  { path: '/koeleskab',     icon: '🥛',  key: 'fridge'   },
  { path: '/kolonial',      icon: '🥫',  key: 'pantry'   },
  { path: '/indkoeb',       icon: '🛒',  key: 'shopping' },
  { path: '/katalog',       icon: '📋',  key: 'catalog'  },
  { path: '/indstillinger', icon: '⚙️',  key: 'settings' },
];

export default function Navigation() {
  const loc = useLocation();
  const nav = useNavigate();
  const { t } = useTranslation();

  return (
    <nav className="ft-tab-bar">
      {TABS.map(tab => {
        const active = loc.pathname === tab.path;
        return (
          <button
            key={tab.path}
            onClick={() => nav(tab.path)}
            className={`ft-tab-item no-select ${active ? 'active' : ''}`}
          >
            <span className="ft-tab-icon">{tab.icon}</span>
            <span className="ft-tab-label">{t('nav.' + tab.key)}</span>
            {active && <span className="ft-tab-dot" />}
          </button>
        );
      })}
    </nav>
  );
}
